import { GameParams } from "supercell-frontend-base/src/validation/game-params";
import { z } from "zod";

const stringBooleanToBoolean = (val: unknown) => {
    if (!val) {
        return undefined;
    }
    return val == "true";
};

export const BoomBeachGameParamsSchema = GameParams.and(
    z.object({
        youngPlayer: z.preprocess(
            stringBooleanToBoolean,
            z.boolean().optional(),
        ),
    }),
);

export type BoomBeachGameParams = z.infer<typeof BoomBeachGameParamsSchema>;
